module.exports = __webpack_public_path__ + "img/2.636d0ba3.png";